<script>
import { mapState, mapActions } from "vuex";
import filterComp from "./filter";
import tableComp from "./table";

export default {
  data() {
    return {
      toolbarOperations: [
        {
          text: "添加",
          key: "add",
        },
        {
          text: "删除",
          key: "delete",
        },
        {
          text: "启用",
          key: "start",
        },
        {
          text: "停用",
          key: "stop",
        },
      ],
      pageInfo: {
        page_num: 1,
        page_size: 8
      },
      oldParams: {},
      checkDatas: []
    };
  },
  components: {
    filterComp,
    tableComp,
  },
  computed: {
    ...mapState([
      'loginAccountInfo'
    ]),
    isManage() {
      return !!this.loginAccountInfo.is_manage;
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapActions([
      "getDirectiveTableList",
      "deleteTableData",
      "updateStatus"
    ]),
    async getList(params, isFirstPage) {
      if (isFirstPage) {
        this.pageInfo.page_num = 1;
      }
      const filterVal = this.$refs.filter.getValue();
      let queryParams = {
        ...this.oldParams,
        ...filterVal,
        ...this.pageInfo
      }
      if (params) {
        Object.keys(this.pageInfo).forEach((key) => {
          if (params.hasOwnProperty(key)) {
            this.pageInfo[key] = params[key];
            queryParams[key] = params[key];
          }
        })
        queryParams = {
          ...queryParams,
          ...params
        };
      }
      try {
        this.$changeLoadingState(true);
        await this.getDirectiveTableList(queryParams);
        this.checkDatas = [];
      } catch (error) {
        console.log(error);
      }
      this.$changeLoadingState(false);
      this.oldParams = queryParams;
    },
    operationHandler(key) {
      switch (key) {
        case 'add':
          console.log(this.$router);
          this.$router.push('/publicResource/publicDirective/add');
          break;
        case 'delete':
          this.batchDelete();
          break;
        case 'start':
        case 'stop':
          this.batchUpdateStatus(key === 'start' ? 'true' : 'false');
          break;
        default:
          break;
      }
    },
    async batchDelete() {
      if (this.checkDatas.length === 0) {
        this.$message.error('请先勾选要删除的数据');
        return;
      }
      const ids = this.checkDatas.reduce((arr, item) => {
        arr.push(item.id);
        return arr;
      }, []);
      try {
        this.$changeLoadingState(true);
        await this.deleteTableData({ids: ids});
        this.$changeLoadingState(false);
        this.getList();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    async batchUpdateStatus(status) {
      if (this.checkDatas.length === 0) {
        this.$message.error('请先勾选要操作的数据');
        return;
      }
      const ids = this.checkDatas.reduce((arr, item) => {
        arr.push(item.id);
        return arr;
      }, []);
      try {
        this.$changeLoadingState(true);
        await this.updateStatus({ids: ids, status});
        this.$changeLoadingState(false);
        this.getList();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    search() {
      this.getList(null, true);
    },
    selectChange(val) {
      this.checkDatas = val;
    }
  },
};
</script>
<template>
  <div class="right-container">
    <filter-comp ref="filter" :isManage="isManage" @search="search"></filter-comp>
    <div class="toolbarOperations" v-if="isManage">
      <el-button
        size="mini"
        v-for="t in toolbarOperations"
        :key="t.key"
        :type="t.key == 'delete' ? 'danger' : 'primary'"
        @click="operationHandler(t.key)"
        >{{ t.text }}</el-button
      >
    </div>
    <table-comp
      :pageNum="pageInfo.page_num"
      :oldParams="oldParams"
      @selectChange="selectChange"
      @getDatas="getList"
    ></table-comp>
  </div>
</template>
<style lang="scss" scoped>
.right-container {
  height: 100%;
  background: #fff;
  padding: 10px;
}
</style>
<style lang="scss">
.toolbarOperations {
  margin-bottom: 16px;
//   .el-button {
//     padding: 10px 12px;
//   }
}
</style>
